import {
  DEFAULT_ROUTE_SORT, RouteSort, RouteSortDirection, RouteSortKey,
} from '../../../types/TRouteSortKey';

const TIMELINE_ROUTE_SORT_LOCAL_STORAGE_KEY = 'timelineRouteSortPreference';

const isRouteSortKey = (value: unknown): value is RouteSortKey => (
  typeof value === 'string' && (Object.values(RouteSortKey) as string[]).includes(value)
);

const isRouteSortDirection = (value: unknown): value is RouteSortDirection => (
  typeof value === 'string' && (Object.values(RouteSortDirection) as string[]).includes(value)
);

/**
 * Reads the stored `{ key, direction }`. Each half falls back to its default independently, so
 * a partial or unknown stored value still hydrates to something valid.
 */
const getTimelineRouteSortPreference = (): RouteSort => {
  try {
    const preferenceJson = localStorage.getItem(TIMELINE_ROUTE_SORT_LOCAL_STORAGE_KEY);
    const stored = preferenceJson ? JSON.parse(preferenceJson) : undefined;
    const key = isRouteSortKey(stored?.key) ? stored.key : DEFAULT_ROUTE_SORT.key;
    const direction = isRouteSortDirection(stored?.direction) ? stored.direction : DEFAULT_ROUTE_SORT.direction;
    return { key, direction };
  } catch {
    return { ...DEFAULT_ROUTE_SORT };
  }
};

const setTimelineRouteSortPreference = (routeSort: RouteSort) => {
  try {
    localStorage.setItem(TIMELINE_ROUTE_SORT_LOCAL_STORAGE_KEY, JSON.stringify(routeSort));
  } catch {
    // Persisting the preference is best-effort; ignore storage failures
    // (e.g. private mode / quota exceeded) so the control still works.
  }
};

export {
  getTimelineRouteSortPreference,
  setTimelineRouteSortPreference,
  TIMELINE_ROUTE_SORT_LOCAL_STORAGE_KEY,
};
